import { keyBy } from "lodash";
import { format } from "date-fns";

import { parseServerTimestampForClient } from "../../common/helpers";
import { DateFormat, formatItemWithUnits } from "../helpers";
import { formatAmount } from "utilities/dist/helpers";
import { buildInvoiceNumberWithBeer } from "utilities/dist/invoice/helpers";
import {
    InvoiceActionsRenderer,
    InvoiceStatusRenderer,
    InvoiceLinkRenderer,
    InvoiceHistoryRenderer,
    InvoiceCustomerRenderer,
    InvoiceEmptyRenderer,
} from "./cellRenderers.component";
import StatusFilter from "./statusFilter";

export const allGridColumns = keyBy(
    [
        {
            filter: false,
            sortable: false,
            headerName: "Invoice history",
            cellRenderer: InvoiceHistoryRenderer,
            pinnedRowCellRenderer: InvoiceEmptyRenderer,
            valueGetter: function ({ data }) {
                return !data ? null : data;
            },
        },
        {
            field: "status",
            headerName: "Status",
            cellRenderer: InvoiceStatusRenderer,
            pinnedRowCellRenderer: InvoiceEmptyRenderer,
            valueGetter: function ({ data }) {
                return !data ? null : data?.status;
            },
            filter: StatusFilter,
        },
        {
            field: "number",
            headerName: "Number",
            valueGetter: function ({ data }) {
                if (!data) return null;

                return buildInvoiceNumberWithBeer(data);
            },
            cellRenderer: InvoiceLinkRenderer,
            pinnedRowCellRenderer: InvoiceEmptyRenderer,
        },
        {
            field: "total",
            headerName: "Total",
            type: "numericColumn",
            filter: "agNumberColumnFilter",
            valueGetter: function ({ data }) {
                if (!data) return null;
                return formatAmount(data.total);
            },
        },
        {
            headerName: "Date",
            field: "invoiced_at",
            filter: "agDateColumnFilter",
            pinnedRowCellRenderer: InvoiceEmptyRenderer,
            valueGetter: ({ data }) => {
                return data && data.invoiced_at
                    ? format(parseServerTimestampForClient(data.invoiced_at), DateFormat)
                    : null;
            },
        },
        {
            headerName: "Due On",
            field: "due_at",
            filter: "agDateColumnFilter",
            pinnedRowCellRenderer: InvoiceEmptyRenderer,
            valueGetter: ({ data, node }) => {
                if (node.rowPinned) {
                    return null;
                }
                return data && data.due_at
                    ? format(parseServerTimestampForClient(data.due_at), DateFormat)
                    : "On Delivery";
            },
        },
        {
            field: "customer",
            headerName: "Customer",
            sortable: false,
            filter: false,
            pinnedRowCellRenderer: InvoiceEmptyRenderer,
            valueGetter: function ({ data }) {
                return data && data.customer
                    ? data.customer.name + ", " + data.customer.address
                    : null;
            },
            cellRenderer: InvoiceCustomerRenderer,
        },

        {
            filter: false,
            field: "items",
            sortable: false,
            suppressMenu: true,
            headerName: "Items",
            valueGetter: formatItemWithUnits,
        },
        {
            filter: false,
            sortable: false,
            field: "actions",
            suppressMenu: true,
            headerName: "Actions",
            cellRenderer: InvoiceActionsRenderer,
            pinnedRowCellRenderer: InvoiceEmptyRenderer,
        },
    ],
    "field"
);
